export default "__VITE_ASSET__0R6aCHMCVUPf9apLhFubFA__"